<template>
  <div class="tabbar">
        <div class="tab-list">
            <div class="tab-item" v-for="item,index in tabList" :key="index" :class="tabIndex==index?'tab-active':''" @click="handleTab(item,index)">{{item.name}}</div>
        </div>
        <div class="match-select" v-if="!playerDetai">
            <div class="ms-list" v-if="tabIndex==0||tabIndex==1||tabIndex==2">
                <div class="ms-item" v-for="item,index in matchList" :key="index" @click="handleMatch(item,index)">
                    <div>{{item.name}}</div>
                    <div v-show="matchIndex==index"></div>
                </div>
            </div>
            <div class="player-select" v-if="tabIndex==3">
                <a-select default-value="性别" style="width: 120px;margin-right:30px" @change="handleChange" placeholder="性别" size="large">
                    <a-select-option value="性别">
                        性别
                    </a-select-option>
                    <a-select-option value="lucy">
                        Lucy
                    </a-select-option>
                </a-select>
                <a-select default-value="项目" style="width: 120px;margin-right:30px" @change="handleChange" placeholder="项目" size="large">
                    <a-select-option value="项目">
                        项目
                    </a-select-option>
                    <a-select-option value="lucy">
                        Lucy
                    </a-select-option>
                </a-select>
                <a-select default-value="代表队" style="width: 120px;margin-right:30px" @change="handleChange" placeholder="代表队" size="large">
                    <a-select-option value="代表队">
                        代表队
                    </a-select-option>
                    <a-select-option value="lucy">
                        Lucy
                    </a-select-option>
                </a-select>
                <div class="player-total">共计 1223 名参赛运动员</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"",
    props: {
    },
    data() {
        return {
            tabIndex:0,
             tabList:[
                {
                    name:"赛程",
                },
                {
                    name:"奖牌榜",
                },
                {
                    name:"成绩",
                },
                {
                    name:"运动员",
                },
            ],
            matchIndex:0,
            playerDetai:false,
            matchList:[
                {
                    id:1,
                    name:"全部"
                },
                {
                    id:2,
                    name:"短跑"
                },
                {
                    id:1,
                    name:"中长跑"
                },
                {
                    id:1,
                    name:"跨栏"
                },
                {
                    id:1,
                    name:"接力赛"
                },
                {
                    id:1,
                    name:"马拉松"
                },
                {
                    id:1,
                    name:"竞走"
                },
                {
                    id:1,
                    name:"跳跃"
                },
                {
                    id:1,
                    name:"投掷"
                },
                {
                    id:1,
                    name:"全能"
                },
            ],
            component:"TrackfieldSchedule",
        }
    },
    methods: {
         handleTab(item,index) {
            this.tabIndex=index
            switch(this.tabIndex){
                case 0:
                    this.component="TrackfieldSchedule"
                    break
                case 1:
                    this.component="TrackfieldMedalTable"
                    break
                case 2:
                    this.component="TrackfieldAchievement"
                    break
                case 3:
                    this.component="TrackfieldAthlete"
                    break
                default:
                    this.component="TrackfieldSchedule"
            }
            this.$emit('setComponent',this.component)
        },
        handleMatch(item,index){
            this.matchIndex=index
        },
        handleChange(){}
    },
}
</script>

<style lang="scss" scoped>
.tabbar{
    width: 100%;
    padding-top: 10px;
  
    .tab-list{
        width: 1200px;
        margin:0 auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #000000;
        .tab-item{
            width:120px ;
            height: 50px;
            line-height: 50px;
            border-radius: 20px 20px 0 0;
            text-align: center;
            margin-right: 20px;
            cursor: pointer;
            font-size: 18px;
        }
    }
    .tab-active{
        background-color:#AA1F23 ;
        color: #ffffff;
        font-size: 22px;
    }
    .match-select{
        width: 100%;
        height: 140px;
        background-color: #F7F7F7;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .ms-list{
            width: 1200px;
            margin:0 auto;
            height: 80px;
            background-color:#ffffff ;
            overflow: hidden;
            display: flex;
            justify-content: flex-start;
            flex-wrap: nowrap;
            align-items: center;
            padding: 0 20px;
            box-sizing: border-box;
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12);
            .ms-item{
                display: flex;
                justify-content: center;
                flex-direction: column;
                color: #000000;
                font-size: 18px;
                align-items: center;
                margin-right: 50px;
                text-align: center;
                cursor: pointer;
                height: 80px;
                div:first-child{
                    width: 100%;
                    padding: 0 5px;
                    margin-bottom: 5px;

                }
                div:last-child{
                    width: 100%;
                    height: 3px;
                    background-color: #AA1F23;
                }
            }
            
        }
        .player-select{
            width: 1200px;
            margin:0 auto;
            height: 80px;
            background-color:#ffffff ;
            overflow: hidden;
            display: flex;
            justify-content: flex-start;
            flex-wrap: nowrap;
            align-items: center;
            padding: 0 20px;
            box-sizing: border-box;
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12);
            position: relative;
            .player-total{
                position: absolute;
                right:20px;
                bottom:20px;
                color: #999999;
                font-size: 14px;
            }
        }
        
    }
}
    
</style>


// WEBPACK FOOTER //
// src/comm/components/match/trackfield/components/TrackfieldMatchTabbar.vue